export default "__VITE_ASSET__3237a8d3__"